import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import dotsIcon from 'assets/images/icons/table-icons.svg';
import dropdownIcon from 'assets/images/icons/dropdown-arrow-white.svg';
import ConfirmationModal from 'components/common-components/ConfirmationModal';
import FormButton from 'components/form-components/FormButton';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const actionConfig = {
  archive: {
    title: 'alert_task_archive_title',
    message: 'alert_task_archive_message',
    text: 'button_archive',
  },
  delete: {
    title: 'alert_task_deletion_title',
    message: 'alert_task_deletion_message',
    text: 'button_delete',
  },
  close: {
    title: 'alert_task_close_title',
    message: 'alert_task_close_message',
    text: 'button_close',
  },
};

const TaskActions = ({ ids, actionsCallBack, isActionButton }) => {
  const { t } = useTranslation();

  const [actionsOptions, setActionsOptions] = useState([]);
  const [confirmModalProps, setConfirmModalProps] = useState(null);

  const isAllowedArchive = () => {
    return ids.every((row) =>
      row.startDate ? new Date(row.startDate) > new Date() || row.status === 'todo' : true,
    );
  };

  const isAllowedClosed = () => {
    return ids.every((row) => row.status === 'todo' && !row.startDate);
  };

  useEffect(() => {
    const allOptions = [
      { value: 'close', displayValue: 'select_close', permission: isAllowedClosed() },
      { value: 'archive', displayValue: 'select_archive', permission: isAllowedArchive() },
      { value: 'delete', displayValue: 'select_delete', permission: true },
    ];

    const visibleOptions = allOptions.filter((option) => option.permission);

    setActionsOptions(visibleOptions);
  }, [ids.length]);

  const handleAction = (_, value) => {
    if (value === 'archive' || value === 'delete' || value === 'close') {
      setConfirmModalProps({
        type: value,
        title: actionConfig[value].title,
        message: actionConfig[value].message,
        text: actionConfig[value].text,
      });
    }
  };

  const handleConfirmAction = () => {
    if (
      confirmModalProps.type === 'archive' ||
      confirmModalProps.type === 'delete' ||
      confirmModalProps.type === 'close'
    )
      actionsCallBack(confirmModalProps.type, { ids: ids.map((i) => i.id) });

    setConfirmModalProps(null);
  };

  return (
    <>
      {confirmModalProps && (
        <ConfirmationModal
          show={!!confirmModalProps}
          title={t(confirmModalProps.title)}
          message={t(confirmModalProps.message)}
          actionList={[
            {
              color: 'black-1',
              text: t('button_cancel'),
              onClick: () => setConfirmModalProps(null),
            },
            {
              color: 'red-1',
              text: t(confirmModalProps.text),
              onClick: () => handleConfirmAction(),
            },
          ]}
        />
      )}
      <MultiLevelSelect
        options={{ children: actionsOptions }}
        value={[]}
        name='action'
        handleChange={(name, value) => handleAction(name, value[0])}
        toggleClasses=''
        toggleComponent={
          <>
            {isActionButton ? (
              <img className='cursor-pointer' src={dotsIcon} />
            ) : (
              <FormButton text='button_action' variant='green-1' icon={dropdownIcon} minWidth />
            )}
          </>
        }
        disabled={!ids.length || !actionsOptions.length}
      />
    </>
  );
};

TaskActions.propTypes = {
  ids: PropTypes.array.isRequired,
  actionsCallBack: PropTypes.func.isRequired,
  isActionButton: PropTypes.bool.isRequired,
};

export default TaskActions;
